import { createSelector, createStructuredSelector } from "reselect";
import { selectUserName } from "scenes/selectors";
import { initialState, State as PhoneAuthenticatorState } from "./redux";

/**
 * Direct selector to the phoneAuthenticator state domain
 */

const selectPhoneAuthenticatorDomain: (any) => PhoneAuthenticatorState = (
  state
) => state.phoneAuthenticator || initialState;

/**
 * Custom selectors to the phoneAuthenticator state
 */
export const selectTextMessageReceived = createSelector(
  selectPhoneAuthenticatorDomain,
  (subState) => subState.textMessageReceived
);
export const selectLoading = createSelector(
  selectPhoneAuthenticatorDomain,
  (subState) => subState.loading
);
export const selectVerifyPassCodeSuccess = createSelector(
  selectPhoneAuthenticatorDomain,
  (subState) => subState.verifyPassCodeSuccess
);

export const currentFlow = createSelector(
  selectPhoneAuthenticatorDomain,
  (subState) => subState.currentFlow
);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  textMessageReceived: selectTextMessageReceived,
  loading: selectLoading,
  verifyPassCodeSuccess: selectVerifyPassCodeSuccess,
  userName: selectUserName,
  currentFlow,
});
